<template>
  <div v-if="loaded">
    <h1
      class="subheadline"
      v-html="content.data.about_bees.header"
    ></h1>
     <div v-html="content.data.about_bees.intro" class="blog__intro text-center pt-4"></div>
    <div class="min-page-height">
      <router-link
        v-for="(page, i) in pages"
        :key="i"
        class="col-md-6 qa__links"
        :to="/o-pszczolach/ + page.index"
        :id="page.index"
        v-show="page.isVisible"
      >
        <div class="blog__box">
          <h2 v-html="page.header" class="blog__subheadline"></h2>
          <div v-html="page.intro" class="blog__content"></div>

          <div>
            <router-link class="blog__btn" :to="/o-pszczolach/ + page.index">
              Czytaj więcej
            </router-link>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    pages: [],
    loaded: false,
  }),
  inject: ["content"],
  mounted() {
    this.scrollToTop();
    this.getDataContent();
  },
  methods: {
    getDataContent() {
      this.pages = this.content?.data.about_bees.articles;
      this.loaded = true;
              document.title = "Blog o pszczołach | Adoptuj Pszczołę";
        document.querySelector('meta[name="description"]').setAttribute("content","Dowiedz się wszystkiego o pszczołach - ich roli w przyrodzie, pracy w ulu i produkowaniu pysznego miodu. Odkryj fascynujący świat pszczół na naszym blogu!");
    },
    getPageRefresh() {
      this.activepageIndex = this.$route.params.id;
      setTimeout(() => {
        this.scrollToTop();
      }, 50);
    },
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
